import { buildEntityLinks } from '@griply/utils';
import { useMemo } from 'react';
import { useElectronTaskCreateDataQuery } from 'shared/hooks/queries/use-electron-task-create-data-query';
import {
  initialDateFormat,
  initialTimeFormat,
} from 'shared/types/date-format-options';
import { InsightsTimeframes } from 'shared/types/insights';
import { initialWeekStartsOn } from 'shared/types/week-days';

import { useApplyPopoverLanguage } from './use-apply-popover-language';

export const useTaskCreateData = () => {
  const { data } = useElectronTaskCreateDataQuery();

  useApplyPopoverLanguage(data?.language);

  return useMemo(
    () => ({
      goals: data?.goals ?? [],
      lifeAreas: data?.lifeAreas ?? [],
      tags: data?.tags ?? [],
      relationships: data?.relationships ?? [],
      links: buildEntityLinks(data?.relationships ?? []),
      timeframe: data?.timeframe ?? InsightsTimeframes.Week,

      weekStartsOn: data?.weekStartsOn ?? initialWeekStartsOn,
      timeFormat: data?.timeFormat ?? initialTimeFormat,
      dateFormat: data?.dateFormat ?? initialDateFormat,
      createHabitAllowed: data?.createHabitAllowed ?? false,
      createHabitTargetAllowed: data?.createHabitTargetAllowed ?? false,
      createHabitIconAllowed: data?.createHabitIconAllowed ?? false,
      createGoalAllowed: data?.createGoalAllowed ?? false,
      createProjectAllowed: data?.createProjectAllowed ?? false,
    }),
    [data],
  );
};
